export default function (array) {
  return array.reduce(function (a, b) {
    return a + b
  }, 0)
}
